export const PERSIST_TAX_FREE_SAVINGS_ACCOUNT_STORE = 'taxFreeSavingsAccount/setValue/persistedAt/persist';
export const persistTaxFreeSavingsAccountStore = () => ({ type: PERSIST_TAX_FREE_SAVINGS_ACCOUNT_STORE });
